import { Component } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { orders } from 'src/app/resources/orders';
import { Order } from 'src/app/models/order.model';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { DashboardTM } from 'src/app/models/dasboardTM.model';
import { LegendLabelsContentArgs } from '@progress/kendo-angular-charts';
import { Site } from 'src/app/models/site.model';

@Component({
    selector: 'app-dashboard-tm-component',
    templateUrl: './dashboard-tm.component.html'
})
export class DashboardTMComponent {
    public selectedChart: 'Trend' | 'Volume' = 'Trend';
    public orders: Order[] = orders;
    public listItemsLocais: Array<Site> = [];
    public data: DashboardTM = {
        id: 0,
        numeroLocais: 0,
        numeroEquipas: 0,
        numeroArmarios: 0,
        numeroFerrramentas: 0,
        numeroUtilizadores: 0,
        numeroTiposFerrramentas: 0,
        estado: [],
        avarias: [],
        condicionadas: [],
        ocupacaoArmarios: [],
        outrosIndicadores: [],
        categories: [],
        graphColor: "green"
    };
    public chartRange: any = {
        start: 0,
        end: 100
    };
    public value = 30;
    public autofit = true;
    public pieData = [
        { label: "0-14", valor: 0.2545 },
        { label: "15-24", valor: 0.1552 },
        { label: "25-54", valor: 0.4059 },
        { label: "55-64", valor: 0.0911 },
        { label: "65+", valor: 0.0933 },
    ];

    public labelContent(args: LegendLabelsContentArgs): string {
        return `${args.dataItem.label}\n${Math.round(args.dataItem.valor * 100)}%`;
    }

    public series: any[] = [
        {
            name: 'Tiger Team',
            data: this.fetchData(1),
            color: '#FF6358'
        },
        {
            name: 'Lemon Team',
            data: this.fetchData(2),
            color: '#F7C62F'
        },
        {
            name: 'Organic Team',
            data: this.fetchData(3),
            color: '#55AB1D'
        },
        {
            name: 'Ocean Team',
            data: this.fetchData(4),
            color: '#28B4C8'
        }
    ];

    public customMsgService: CustomMessagesService;

    constructor(public intl: IntlService, public messages: MessageService, private api: ApiService, private notificationService: NotificationService,) {
        this.customMsgService = this.messages as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('escolherLocal');
        this.api
            .getRequest<BaseHttpResponse<Site[]>>("Local/GetLocais")
            .then((data) => {
                this.listItemsLocais = data.value;
            })
            .catch((err) => { });
        this.customMsgService = this.messages as CustomMessagesService;
        this.load(undefined);
    }

    public placeHolder: any = {
        nome: "",
        id: undefined,
    };

    public selectionChange(value: Site): void {
        this.load(value.id);
    }

    load(idLocal: number | undefined) {
        let endpoint = idLocal == undefined ? "Dashboard/GetDadosTM" : "Dashboard/GetDadosTM?idLocal=" + idLocal;
        this.api
            .getRequest<BaseHttpResponse<DashboardTM>>(endpoint)
            .then((data) => {
                this.data = data.value;
            })
            .catch((err) => { });
    }

    public fromDate(date: Date) {
        this.updateSeries();
    }

    public toDate(date: Date) {
        this.updateSeries();
    }

    public updateSeries() {
        this.series.map((series, index) => {
            return (series.data = this.fetchData(index + 1));
        });
    }

    public fetchData(team: number) {
        return this.orders.map((dataItem: any) => {
            if (dataItem.teamID === team) {
                return dataItem.orderTotal;
            }
        });
    }

    public toAnyData(va: number) {
        var arr = new Array<any>();
        arr.push(va);
        return arr;
    }

}
